module.exports = __webpack_public_path__ + "app/assets/images/woman6-e825e56ce5f07545df05453201d50871.jpg";